import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/global.scss'

Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  console.error('[Vue Error]', err, info)
}

window.addEventListener('unhandledrejection', event => {
  console.error('[UnhandledRejection]', event.reason)
  event.preventDefault()
})

// 反爬虫 & 禁止复制保护（仅生产环境）
// if (process.env.NODE_ENV === 'production') {
//   document.addEventListener('contextmenu', e => e.preventDefault())
//   document.addEventListener('selectstart', e => e.preventDefault())
//   document.addEventListener('copy', e => e.preventDefault())
//   document.addEventListener('cut', e => e.preventDefault())
//   document.addEventListener('dragstart', e => e.preventDefault())
//   document.addEventListener('keydown', e => {
//     if (e.ctrlKey && ['c','a','s','u','p'].includes(e.key.toLowerCase())) e.preventDefault()
//     if (e.key === 'F12') e.preventDefault()
//     if (e.ctrlKey && e.shiftKey && ['i','j','c'].includes(e.key.toLowerCase())) e.preventDefault()
//   })
// }

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
